import { BritishColumbiaObstetricalFilePage, BritishColumbiaObstetricalFilePageState } from "@/Patient/Components/MedicalNote/Obstetric/Form/BritishColumbia/BritishColumbiaObstetricalFilePage";
import { ObstetricalResourcesAnxietyScreeningSection } from "@/Patient/Components/MedicalNote/Obstetric/Form/Common/Page/Resources/Subcomponent/ObstetricalResourcesAnxietyScreeningSection";
import { ObstetricalResourcesDepressionScreeningSection } from "@/Patient/Components/MedicalNote/Obstetric/Form/Common/Page/Resources/Subcomponent/ObstetricalResourcesDepressionScreeningSection";
import { ObstetricalResourcesTAceScreeningSection } from "@/Patient/Components/MedicalNote/Obstetric/Form/Common/Page/Resources/Subcomponent/ObstetricalResourcesTAceScreeningSection";
import { IObstetricalFilePageProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/ObstetricalFilePage";
import { BritishColumbiaObstetricalFileForm } from "@/Patient/Models/ObstetricalFile/BritishColumbia/BritishColumbiaObstetricalFileForm";
import { BritishColumbiaObstetricalFileResourcesDiscussionTopics } from "./Subcomponent/BritishColumbiaObstetricalFileResourcesDiscussionTopics";
import { BritishColumbiaObstetricalFileResourcesEdinburghScale } from "./Subcomponent/BritishColumbiaObstetricalFileResourcesEdinburghScale";
import { BritishColumbiaObstetricalFileWeightGainRecommendationSection } from "./Subcomponent/BritishColumbiaObstetricalFileWeightGainRecommendationSection";

import FundusHeightByGestationalAge from "./_images/FundusHeightByGestationalAge.png";

class BritishColumbiaObstetricalFileResources extends BritishColumbiaObstetricalFilePage<BritishColumbiaObstetricalFilePageState> {
    private readonly componentId = "british-columbia-obstetrical-file-resources";

    protected initState(props: IObstetricalFilePageProps<BritishColumbiaObstetricalFileForm>): void {
        this.mutateState(s => s.form = new BritishColumbiaObstetricalFileForm(props.form));
    }

    protected renderPageContent(): JSX.Element {
        return (
            <div id={this.componentId} className="bc-antenatal-resources">
                <div className="border border-bottom">
                    <BritishColumbiaObstetricalFileWeightGainRecommendationSection {...this.getSubcomponentBaseProps()} />
                </div>
                <div className="border border-bottom">
                    <div className="section">
                        <div className="row">
                            <div className="col-md-6">
                                <ObstetricalResourcesAnxietyScreeningSection<BritishColumbiaObstetricalFileForm>
                                    {...this.getSubcomponentBaseProps()}
                                    model={this.props.form.Resources.AnxietyScreening}
                                    mutateAnxietyScreeningStateWithFormUpdate={(mutation, then) => this.mutateModelStateWithFormUpdate(s => mutation(s.form.Resources.AnxietyScreening), then)}
                                    encounterId={this.props.encounter.Id}
                                    patientContactFacetId={this.props.patient.PatientResponse.ContactFacet_id}
                                    consultationDate={this.props.encounter.ConsultationDate}
                                />
                            </div>
                            <div className="col-md-6">
                                <ObstetricalResourcesDepressionScreeningSection<BritishColumbiaObstetricalFileForm>
                                    {...this.getSubcomponentBaseProps()}
                                    model={this.props.form.Resources.DepressionScreening}
                                    mutateModel={mutation => this.mutateModelStateWithFormUpdate(s => mutation(s.form.Resources.DepressionScreening))}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="border border-bottom flex-display">
                    <ObstetricalResourcesTAceScreeningSection<BritishColumbiaObstetricalFileForm>
                        {...this.getSubcomponentBaseProps()}
                        model={this.state.form.Resources.TaceScreening}
                        mutateTAceScreeningStateWithFormUpdate={mutation => this.mutateModelStateWithFormUpdate(s => mutation(s.form.Resources.TaceScreening))}
                        className="section border border-right"
                        normalTextSubtitle
                    />
                    <img
                        src={FundusHeightByGestationalAge}
                        className="section"
                        height="380px"
                    />
                </div>
                <div className="border border-bottom">
                    <BritishColumbiaObstetricalFileResourcesEdinburghScale {...this.getSubcomponentBaseProps()} />
                </div>
                <div className="borer border-bottom">
                    <BritishColumbiaObstetricalFileResourcesDiscussionTopics
                        {...this.getSubcomponentBaseProps()}
                    />
                </div>
            </div>
        );
    }
}

export { BritishColumbiaObstetricalFileResources };
